module.exports = __webpack_public_path__ + "img/instruments.917be1e3.svg";